import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

import type { StoryListLatestFilteredProps } from "./StoryListLatestFiltered";

export default function integrityCheck({
    items,
}: StoryListLatestFilteredProps): IntegrityStatus {
    return checkItemArrayIntegrity(items);
}
